export function filterUniqueProducts(products, uniqueProperty) {
    const seen = new Set();
    return products.filter(product => {
        const isDuplicate = seen.has(product[uniqueProperty]);
        if (!isDuplicate) {
            seen.add(product[uniqueProperty]);
            return true;
        }
        return false;
    });
} 

export const redirect = (text,searchText) => {
    window.location.href = "/danh-sach-san-pham?searchtext=" + (text?text:(searchText??""));
}